import vert from './customDisplacementFilter.vert.glsl';
import frag from './customDisplacementFilter.frag.glsl';


/**
 * The DisplacementFilter class uses the pixel values from the specified texture (called the displacement map) to perform a displacement of an object.
 * You can use this filter to apply all manor of crazy warping effects
 * Currently the r property of the texture is used to offset the x and the g property of the texture is used to offset the y.
 *
 * @class
 * @extends PIXI.AbstractFilter
 * @memberof PIXI.filters
 * @param sprite {PIXI.Sprite} the sprite used for the displacement map. (make sure its added to the scene!)
 */
function CustomDisplacementFilter(sprite, scale)
{
    var maskMatrix = new PIXI.Matrix();
    sprite.renderable = false;

    PIXI.AbstractFilter.call(this,
        // vertex shader
        vert,
        // fragment shader
        frag,
        // uniforms
        {
            mapSampler:     { type: 'sampler2D', value: sprite.texture },
            otherMatrix:    { type: 'mat3', value: maskMatrix.toArray(true) },
            scale:          { type: 'v2', value: { x: 1, y: 1 } },
            maskBox:        { type: '4f', value: [0.3, 0.01, 0.7, 0.7]}
        }
    );

    this.maskSprite = sprite;
    this.maskMatrix = maskMatrix;

    if (scale === null || scale === undefined)
    {
        scale = 20;
    }

    this.scale = new PIXI.Point(scale, scale);
}

CustomDisplacementFilter.prototype = Object.create(PIXI.AbstractFilter.prototype);
CustomDisplacementFilter.prototype.constructor = CustomDisplacementFilter;

CustomDisplacementFilter.prototype.applyFilter = function (renderer, input, output)
{
    var filterManager = renderer.filterManager;

    filterManager.calculateMappedMatrix(input.frame, this.maskSprite, this.maskMatrix);

    this.uniforms.otherMatrix.value = this.maskMatrix.toArray(true);
    this.uniforms.scale.value.x = this.scale.x * (1/input.frame.width);
    this.uniforms.scale.value.y = this.scale.y * (1/input.frame.height);

    var shader = this.getShader(renderer);
     // draw the filter...
    filterManager.applyFilter(shader, input, output);
};


Object.defineProperties(CustomDisplacementFilter.prototype, {
    /**
     * The texture used for the displacement map. Must be power of 2 sized texture.
     *
     * @member {PIXI.Texture}
     * @memberof PIXI.filters.DisplacementFilter#
     */
    map: {
        get: function ()
        {
            return this.uniforms.mapSampler.value;
        },
        set: function (value)
        {
            this.uniforms.mapSampler.value = value;

        }
    },
    maskBox: {
        get: function() {
            return this.uniforms.maskBox.value;
        },
        set: function(value) {
            this.uniforms.maskBox.value = value;
        }
    },
    sprite: {
        get: function() {
            return this.maskSprite;
        },

        set: function(value) {
            value.renderable = false;
            this.uniforms.mapSampler.value = value.texture;
            this.maskSprite = value;
        }
    }
});


module.exports = CustomDisplacementFilter;



/** WEBPACK FOOTER **
 ** ./src/js/views/shaders/customDisplacementFIlter.js
 **/